export default {
  init() {
    // JavaScript to be fired on the about us page
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/about.js